// extracted by mini-css-extract-plugin
var _1 = "tjs-slide-up-fade-in__enter";
var _2 = "tjs-slide-up-fade-in__enter-active";
var _3 = "tjs-slide-up-fade-in__enter-active";
var _4 = "tjs-slide-up-fade-in__exit";
var _5 = "tjs-slide-up-fade-in__exit-active";
var _6 = "tjs-slide-up-fade-in__exit-active";
export { _1 as "enter", _2 as "enter-active", _3 as "enterActive", _4 as "exit", _5 as "exit-active", _6 as "exitActive" }
export default { "enter": _1, "enter-active": _2, "enterActive": _3, "exit": _4, "exit-active": _5, "exitActive": _6 }
